import React, { useEffect } from 'react';
import '../App.css';
import 'latex.css/dist/style.css';

const ReportHeader = ({ title, subtitle, author, date, isDarkMode, toggleDarkMode, isNewest }) => {
  useEffect(() => {
    // This will add or remove the class based on the isDarkMode prop
    const body = document.body;
    if (isDarkMode) {
      body.classList.add('latex-dark');
    } else {
      body.classList.remove('latex-dark');
    }
  }, [isDarkMode]); // Effect runs only when isDarkMode prop changes

  return (
    <header>
      <p className="author">{author}</p>
      <p className="date">{date}</p>
    </header>
  );
};

export default ReportHeader;
